import React from 'react';
import { Card, Accordion } from 'react-bootstrap';
import Select from "react-dropdown-select";
import CustomDropdownWithSearch from '../CustomDropdownWithSearch';
import CustomControl from '../CustomControl';
import DebounceInput from 'react-debounce-input';
import {
  capitalizeWordsText,
} from "../../Functions/TextTransform";

export default function StepRoomLablePleatedDraperyOnly({
 ContextAwareToggle,
 t,
 stepSelectedLabel,
 pageLanguage,
 requiredStep,
 selectedRoomLabel,
 setSelectedRoomLabel,
 roomLabelChanged,
 setDeps,
 setCart,
 pageLoad,
 rodsLoad,
 rodsLoad2,
 rooms,
 setCartLoading,
 roomLabelText,
 setRoomLabelText,
 detailsShow,
 setDetailsShow,
 moreInfoInput,
 setMoreInfoInput,
 NextStep,
 multipleFileUploadRef,
 baseURLUploadPdf,
 baseURLUploadImg,
 addUploadFileUrl,
 setUploadedImages,
 setUploadedPDFs,
 addFailedFileToParent,
 setUploadingFiles,
 allFilesSorted,
 handleDeleteFile2,
 formatFileSize,
 UploadedFilesList,
 MultipleFileUpload,
 step5,
 step3,
}) {
  return (
   <Card>
   <Card.Header>
     <ContextAwareToggle
       eventKey="10"
       stepNum={step5 === "Full" && step3 === "false" ? t("8") : t("9")}
       stepTitle={t("zebra_step6")}
       stepRef="10"
       type="2"
       required={requiredStep["10"]}
       stepSelected={
         stepSelectedLabel["10"] === undefined ? "" : stepSelectedLabel["10"]
       }
     />
   </Card.Header>
   <Accordion.Collapse eventKey="10">
     <Card.Body>
       <div className="card_body card_body_radio">
         <div className="box100 selectInput_section">
           <div className="room_select">
             <label className="select_label">{t("Room")}</label>
             <div className="select_container">
               <Select
                 className="select"
                 placeholder={t("Please Select")}
                 portal={document.body}
                 dropdownPosition="bottom"
                 dropdownHandle={false}
                 dropdownGap={0}
                 values={selectedRoomLabel}
                 onDropdownOpen={() => {
                   let temp1 = window.scrollY;
                   window.scrollTo(window.scrollX, window.scrollY + 1);
                   setTimeout(() => {
                     let temp2 = window.scrollY;
                     if (temp2 === temp1)
                       window.scrollTo(window.scrollX, window.scrollY - 1);
                   }, 100);
                 }}
                 dropdownRenderer={({ props, state, methods }) => (
                   <CustomDropdownWithSearch
                     props={props}
                     state={state}
                     methods={methods}
                   />
                 )}
                 contentRenderer={({ props, state, methods }) => (
                   <CustomControl props={props} state={state} methods={methods} />
                 )}
                 onChange={(selected) => {
                   if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                     setDeps("", "1001", 2);
                     roomLabelChanged(selected[0], "10", false);
                     setSelectedRoomLabel(selected);
                     setCart(
                       "RoomNameFa",
                       rooms["fa"].find((opt) => opt.value === selected[0].value).label,
                       "",
                       "RoomNameEn",
                       [selected[0].value]
                     );
                   }
                 }}
                 options={rooms[pageLanguage]}
               />
             </div>
           </div>
           <div className="room_select">
             <label className="select_label">{t("Window Description")}</label>
             <DebounceInput
               debounceTimeout={1500}
               onKeyDown={() => setCartLoading(true)}
               type="text"
               placeholder={t("E.g. Bedroom east wall")}
               className="form-control window_name"
               name="order_window_name"
               value={roomLabelText}
               onChange={(e) => {
                 setTimeout(() => {
                   if (e.target.value === "") {
                     setDeps("1002", "");
                   } else {
                     setDeps("", "1002", 2);
                   }
                   roomLabelChanged(capitalizeWordsText(e.target.value), "10", true);
                   setRoomLabelText(capitalizeWordsText(e.target.value));
                   setCart("WindowName", capitalizeWordsText(e.target.value));
                 }, 300);
               }}
             />
           </div>
         </div>

         <div className="box100 upload_section">
<div
  className="big_box big_box-new"
  style={{
    border: "0.09375rem solid #aaa",
    height: detailsShow ? "8.5rem" : "3rem",
    margin: "1.25rem auto",
    width: "85%",
    display: "inline-flex",
    position: "relative",
    transition: "height 0.3s ease",
  }}
>
  <div
    className="upload_button_displayer"
    onClick={() => {
      if (detailsShow) setDetailsShow(false);
      else setDetailsShow(true);
    }}
  >
    <p className="d-flex align-items-center"
      style={{
        position: "absolute",
        top: "0.8rem",
        left: "0.5rem",
        right: "0.5rem",
        width: "100%",
        zIndex: "2",
        cursor: "pointer",
      }}
    >
      <span className="details-label unselectable">
        {detailsShow ? t("room Hide Details") : t("Add Room Image")}
        <h5>{detailsShow ? "" : t("(Optional)")}</h5>
      </span>
      <span className="details_indicator">
        {detailsShow && (
          <img
            className="arrow_down img-fluid"
            src={require("../../Images/public/arrow_up.svg").default}
            alt=""
          />
        )}
        {!detailsShow && (
          <img
            className="arrow_down img-fluid"
            src={require("../../Images/public/arrow_down.svg").default}
            alt=""
          />
        )}
      </span>
    </p>
  </div>

  <div
    className="uploaded_images_section"
    style={{
      display: detailsShow ? "block" : "none",
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "100%",
      textAlign: "center",
    }}
  ></div>

  <MultipleFileUpload
    ref={multipleFileUploadRef}
    baseURLUploadPdf={baseURLUploadPdf}
    baseURLUploadImg={baseURLUploadImg}
    addUploadFileUrl={addUploadFileUrl}
    maxSizeMB={5}
    acceptedFormats={[
      "image/jpeg",
      "image/png",
      "image/gif",
      "application/pdf",
    ]}
    t={t}
    detailsShow={detailsShow}
    setUploadedImages={setUploadedImages}
    setUploadedPDFs={setUploadedPDFs}
    addFailedFileToParent={addFailedFileToParent}
    onFilesChange={setUploadingFiles}
  />

  {detailsShow && (
    <p 
    className='d-flex text-muted'
      style={{
        position: "absolute",
        bottom: "0.5rem",
        width: "100%",
        fontSize: "0.8rem",
        padding: "0 0.6rem",
        direction: pageLanguage === "fa" ? "rtl" : "ltr",
      }}
    >
      {t(
        "JPG, PNG, GIF, PDF. Maximum file size 5MB."
      )}
    </p>
  )}
</div>
         </div>
         <div
           className={`box100 hidden_upload_section ${
             detailsShow ? "show_upload_section" : ""
           }`}
         ></div>
         <div className="box100 uploaded_name_section">
           <div className="mid_upload">
             {allFilesSorted.length > 0 && (
               <UploadedFilesList
                 files={allFilesSorted}
                 onDelete={handleDeleteFile2}
                 formatFileSize={formatFileSize}
                 pageLanguage={pageLanguage}
               />
             )}
           </div>
         </div>

         <div className="more_info_section">
           <div className="more_info_container">
             <h3 className="more_info_title">{t("Anything else we need to know?")}</h3>
             <div className="more_info_desc">
               <p>{t("orderNotes1")}</p>
             </div>
           </div>
           <div className="more_info_input_container">
             <DebounceInput
               debounceTimeout={1500}
               onKeyDown={() => setCartLoading(true)}
               className="more_info_input"
               type="text"
               name="more_info_input"
               value={moreInfoInput}
               placeholder=""
               onChange={(e) => {
                 setTimeout(() => {
                   setCart("moreInfoInput", e.target.value);
                   setMoreInfoInput(e.target.value);
                 }, 300);
               }}
             />
           </div>
         </div>
         <NextStep currentStep="10" eventKey="11">
           {t("NEXT STEP")}
         </NextStep>
       </div>
       <div className=" accordion_help">
         <div className=" help_container">
           <div className=" help_column help_left_column">
             <p className=" help_column_header">{t("step6_help_1")}</p>
             <ul className=" help_column_list">
               <li className=" no_listStyle">{t("step6_help_2")}</li>
             </ul>
           </div>
           <div className=" help_column help_right_column">
             <p className=" help_column_header">{t("step6_help_3")}</p>
             <ul className=" help_column_list">
               <li className=" no_listStyle">{t("step6_help_4")}</li>
             </ul>
           </div>
         </div>
       </div>
     </Card.Body>
   </Accordion.Collapse>
 </Card>
  )
}
